import { gql } from "@apollo/client";

export const SetActiveRoleMutation = gql`
  mutation setActiveRole($role: String!) {
    setActiveRole(input: { role: $role }) {
      setActiveRoleOutput {
        activeRole
      }
    }
  }
`;
